const Stern = ({ color, text }) => {
  return (
    <svg
      viewBox="0 0 261 209"
      fill="transparent"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="none">
      <style>
        {` 
    .stern{
        fill: ${color}; 
        stroke: #2228; 
        stroke-width: 2;
    }
    #SeasonName {
        white-space: pre; 
        font-family: Leutwylershand; 
        font-size: 24px; font-weight: 500; 
        letter-spacing: 0em;
        text-anchor:middle;
        fill: ${color}; 
    }
    `}
      </style>
      <defs>
        <filter id="brighten">
          <feComponentTransfer>
            <feFuncR type="linear" slope=".25" />
            <feFuncG type="linear" slope=".25" />
            <feFuncB type="linear" slope=".25" />
          </feComponentTransfer>
        </filter>
      </defs>
      <g id="stern">
        <g id="BlaseStern">
          <path
            id="Vector 1"
            d="M71.1278 60.0035C71.0218 60.78 70.1046 61.1384 69.5003 60.6394L56.626 50.0095C56.035 49.5215 55.1372 49.8525 55.0044 50.6074L53.8258 57.3096C53.7946 57.487 53.8119 57.6695 53.8759 57.8379L57.4329 67.2026C57.6401 67.7478 57.3385 68.3539 56.7786 68.5175L32.1785 75.7055C31.3159 75.9576 31.1977 77.131 31.9927 77.55L43.6093 83.6725C44.2014 83.9846 44.3258 84.7789 43.8573 85.257L27.8556 101.588C27.2424 102.214 27.6732 103.27 28.5491 103.288L54.2049 103.821C54.9208 103.836 55.3895 104.576 55.0967 105.23L53.038 109.823L47.4531 123.675C47.1752 124.365 47.7196 125.106 48.4603 125.046L50.4614 124.886C50.5197 124.881 50.5774 124.872 50.634 124.857L71.8426 119.327C72.4956 119.157 73.1262 119.669 73.0937 120.343L72.2158 138.55C72.1772 139.349 73.0461 139.868 73.7312 139.454L90.3785 129.411C90.8727 129.113 91.5159 129.294 91.7822 129.806L94.0652 134.195C94.1313 134.322 94.1693 134.462 94.1767 134.605L95.0268 151.09C95.065 151.83 95.8674 152.273 96.5142 151.911L117.452 140.183C117.514 140.148 117.579 140.12 117.647 140.099L119.714 139.464C120.295 139.286 120.9 139.663 120.995 140.263L123.688 157.227C123.793 157.891 124.512 158.264 125.116 157.968L141.001 150.174C141.059 150.146 141.119 150.123 141.18 150.107L146.287 148.722C146.67 148.618 147.078 148.751 147.327 149.06L160.12 164.962C160.491 165.423 161.18 165.463 161.601 165.047L175.196 151.637C175.615 151.224 176.297 151.26 176.671 151.714L179.588 155.263C179.662 155.353 179.751 155.429 179.851 155.488L191.776 162.562C191.817 162.586 191.86 162.607 191.904 162.625L197.371 164.892C198.082 165.187 198.846 164.601 198.745 163.837L196.135 144.052C196.066 143.535 196.407 143.052 196.917 142.943L217.602 138.522C218.42 138.347 218.675 137.305 218.03 136.773L204.813 125.859C204.387 125.508 204.326 124.878 204.678 124.452L214.229 112.873C214.325 112.757 214.393 112.621 214.429 112.475L214.777 111.055C214.929 110.437 214.473 109.837 213.837 109.817L198.669 109.355C198.419 109.347 198.19 109.214 198.06 109V109C197.923 108.774 197.917 108.491 198.044 108.26L208.843 88.672C209.245 87.9421 208.631 87.0692 207.808 87.2019L192.437 89.6814C191.73 89.7954 191.136 89.1511 191.306 88.4556L191.453 87.857C191.465 87.8109 191.479 87.7656 191.497 87.7216L194.515 80.2364C194.548 80.1537 194.57 80.0669 194.581 79.9783L195.609 71.1652C195.637 70.9217 195.48 70.6951 195.242 70.6366V70.6366C195.142 70.6121 195.037 70.6199 194.942 70.6587L171.252 80.3386C170.701 80.5637 170.077 80.2609 169.913 79.689L164.139 59.5915C163.936 58.8849 163.066 58.6316 162.515 59.1189L149.177 70.9263C148.7 71.3487 147.954 71.2229 147.642 70.6672L142.36 61.2623L134.147 49.93C133.745 49.3754 132.917 49.3798 132.522 49.9387L123.949 62.0395C123.554 62.5964 122.73 62.6032 122.327 62.0529L112.661 48.8773C112.252 48.3204 111.415 48.3355 111.027 48.9069L103.125 60.5406C102.743 61.1024 101.924 61.1285 101.508 60.5922L88.0007 43.2045C87.4878 42.5442 86.4393 42.7674 86.2399 43.5794L82.7908 57.6204C82.6137 58.3418 81.7397 58.625 81.1731 58.1447L73.7877 51.8841C73.1855 51.3736 72.257 51.7295 72.1503 52.5117L71.1278 60.0035Z"
            className="stern"
          />
        </g>
        <text
          id="SeasonName"
          transform="translate(71.6797 60.043) rotate(15.8008)"
          filter="url(#brighten)"
          xmlSpace="preserve">
          <tspan x="62.09375" y="36.1582">
            {text}
          </tspan>
        </text>
      </g>
    </svg>
  );
};

export default Stern;
